export const routes = {
  login: {
    name: 'Login',
    path: import.meta.env.VITE_APP_APP_HOST + '/login',
  },
  signup: {
    name: 'Sign Up',
    path: import.meta.env.VITE_APP_APP_HOST + '/signup',
  },
  root: {
    name: 'Home',
    path: '/',
  },
  home: {
    name: 'Home',
    path: '/home',
  },
  contact: {
    name: 'Contact us',
    path: '/contacts',
  },
  termsAndConditions: {
    name: 'Terms and Conditions',
    path: '/terms-and-conditions',
    container: 'TermsAndConditions',
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    container: 'PrivacyPolicy',
  },
};
